export const currentPage = (startNum, limit = 20) => {
    return (startNum - 1) / limit + 1;
};

export const numberRange = (startNum, endNum) =>
    `${startNum} - ${endNum}` || '0 - 0';
export const nextUrl = (endNum, total, baseUrl, currentPage) => {
    return endNum < total ? `${baseUrl}?page=${currentPage + 1}` : null;
};
export const prevUrl = (currentPage, baseUrl) => {
    return currentPage > 1 ? `${baseUrl}?page=${currentPage - 1}` : null;
};

export const paginationProps = (
    startNum,
    endNum,
    total,
    baseUrl,
    limit,
    metricOnClick
) => {
    const currentPageNum = currentPage(startNum, limit);

    return {
        numberRange: numberRange(startNum, endNum),
        nextUrl: nextUrl(endNum, total, baseUrl, currentPageNum),
        prevUrl: prevUrl(currentPageNum, baseUrl),
        metricOnClick,
    };
};

export const hasNext = (page, limit, total) => {
    return page * limit < total;
};

export const hasPrev = (page) => {
    return page > 1;
};
